import RequestProduct from './RequestProduct.vue';

export { RequestProduct };



// WEBPACK FOOTER //
// ./src/modules/home/requestProduct/index.js